export default function ProgressBar({ results, total }) {
  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      {Array.from({ length: total }).map((_, i) => {
        let className = 'icon'
        if (i < results.length) {
          className += results[i] ? ' icon-correct icon-reveal' : ' icon-incorrect icon-reveal'
        }
        return <div key={i} className={className} />
      })}
    </div>
  )
}